import { create } from 'zustand';
import { Profile } from '@/lib/types/profile';

// Separate store for the authenticated user's profile
interface AuthUserProfileState {
  profile: Profile | null;
  isLoading: boolean;
  setProfile: (profile: Profile | null) => void;
  updateProfile: (updates: Partial<Profile>) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const useAuthUserProfileStore = create<AuthUserProfileState>((set) => ({
  profile: null,
  isLoading: false,
  setProfile: (profile) => set({ profile }),
  updateProfile: (updates) => 
    set((state) => ({
      profile: state.profile ? { ...state.profile, ...updates } : null
    })),
  setIsLoading: (isLoading) => set({ isLoading }),
}));

// Separate store for viewed profiles
interface ViewedProfileState {
  profile: Profile | null;
  isLoading: boolean;
  setProfile: (profile: Profile | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  resetProfile: () => void;
}

export const useViewedProfileStore = create<ViewedProfileState>((set) => ({
  profile: null,
  isLoading: false,
  setProfile: (profile) => set({ profile }),
  setIsLoading: (isLoading) => set({ isLoading }),
  resetProfile: () => set({ profile: null }),
}));

// Maintain the original store for backward compatibility
// but make it reference the auth user profile store
export const useProfileStore = useAuthUserProfileStore;